export default __webpack_public_path__ + "static/media/diver_loader _a.435c0eab.gif";